<template>
    <div class="container">
        <div class="d-flex flex-column flex-fill h-100 bg--white border-radius m-t-25 m-b-25 p-30">
            <ak-form
                :bundle="bundle"
                :definition="definition"
                :objectId="objectId"
                :relationString="relationString"
                :key="formKey"
                v-on="$listeners"
            >
                <template v-slot:submit-button="{form,submit,baseUriControls,setLoading}">
                    <div v-if="form.footerWidgets && form.footerWidgets.widgets.length">
                        <div class="ak-button-group flex-row-reverse justify-content-end">
                            <ak-widget
                                v-for="widget in form.footerWidgets.widgets"
                                :key="widget.id"
                                :type="widget.type"
                                :callbacks="widget.callbacks"
                                :slot="widget.slot"
                                :objectId="objectId"
                                :contextType="form.footerWidgets.contextType"
                                :callbackUri="baseUriControls"
                                :attributes="{ ...widget.attributes, id: widget.id, baseUri: baseUriControls, relationString: relationString, currentObjectId: objectId}"
                                @submit="submit"
                                @widget-event-callback-loading="setLoading"
                                v-on="$listeners"
                            />
                        </div>
                    </div>
                </template>
            </ak-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Form',
    data() {
        return {
            showConfirm: false,
        }
    },
    computed: {
        bundle() {
            return this.$route.params.bundle;
        },
        definition() {
            return this.$route.params.definition;
        },
        objectId() {
            // Since the full screen forms are currently only used for configuration
            // for the entire account, we apply the current account's (hash) ID as
            // the objectId that needs to be applied.
            // This also avoids having that objectId to be put in the url, where it
            // could then be changed, and from there on, we'd get more issues...
            return this.$userInterfaceHandler.getUserInterface().account.id;
        },
        relationString() {
            return this.$route.params.relationString;
        },
        formKey() {
            // This form key is required so that Vue will pick up on the change of
            // the form, and actually load the respective form when navigating from
            // one form to the other.
            return this.bundle + this.definition + this.objectId;
        }
    },
    methods: {

    }
}
</script>
